import {
  I18N_SUBMIT_CONFIRMATION_BUTTON_KEY,
  I18N_SUBMIT_DISCLAIMER_KEY,
  I18N_WARNINGS_CHECK_LABEL_KEY
} from 'lf-at-theme';

/**
 * App i18n object for the en-US locale.
 */

export const appI18NEnUS: Record<string, any> = {
  '*': {
    saveFileName: 'oss-non-union-registration',
    [I18N_SUBMIT_DISCLAIMER_KEY]: 'You are about to submit a Non-Union Scheme registration. Making it so you are agreeing that you are not established in the European Union and that the information provided in this form is true, complete and accurate',
    [I18N_SUBMIT_CONFIRMATION_BUTTON_KEY]: 'Submit',
    [I18N_WARNINGS_CHECK_LABEL_KEY]: 'I declare that I am aware of the warnings generated by the data of this declaration.',

    ["modalYesBtn"]: 'Confirm',
    ["modalNoBtn"]: 'Cancel',

    ["schemeConditionsTitle"]: 'Admission Conditions',
    ["schemeConditions"]: `
      <p>To register in this scheme you should meet these conditions:</p>
      <ul>
        <li>You are a <strong>supplier of services</strong> (including TBE services) <strong>not established in the EU</strong>. You supply services to consumers and the place of supply is in the EU.</li>
      </ul>
    `,

  }
};
